/*
  celebra-video-lazy.js
  Ne charge la video d'un media produit que lorsqu'il devient reellement visible.
  But : conserver la qualite d'origine (1080p) sans telecharger toutes les videos
  de la galerie en meme temps, ce qui saturait la bande passante et bloquait
  certaines videos a zero octet.
*/
(function () {
  var SEUIL = 0.25;
  var io = null;
  var planifie = false;

  function contientUneVideo(el) {
    if (el.querySelector('video')) return true;
    var tpl = el.querySelector('template');
    return !!(tpl && tpl.content && tpl.content.querySelector('video'));
  }

  function eligible(el) {
    // on laisse la fenetre de zoom en lecture sur clic
    return !el.closest('dialog') && contientUneVideo(el);
  }

  function traiter(entrees) {
    for (var i = 0; i < entrees.length; i++) {
      var entree = entrees[i];
      var el = entree.target;
      var video = el.querySelector('video');
      var visible = entree.isIntersecting && entree.intersectionRatio >= SEUIL;

      if (visible) {
        if (video) {
          // deja presente dans le DOM : on relance simplement la lecture
          if (video.hasAttribute('autoplay') && video.paused) {
            var p = video.play();
            if (p && typeof p.catch === 'function') p.catch(function () {});
          }
        } else if (typeof el.loadContent === 'function') {
          // pas encore chargee : on demande au composant du theme de l'injecter
          try { el.loadContent(false); } catch (e) {}
        }
      } else if (video && !video.paused) {
        video.pause();
      }
    }
  }

  function balayer() {
    planifie = false;
    if (!io) return;
    var liste = document.querySelectorAll('deferred-media');
    for (var i = 0; i < liste.length; i++) {
      var el = liste[i];
      if (el.__celebraLazy) continue;
      if (!eligible(el)) continue;
      el.__celebraLazy = true;
      io.observe(el);
    }
  }

  function planifierBalayage() {
    if (planifie) return;
    planifie = true;
    (window.requestAnimationFrame || setTimeout)(balayer);
  }

  function demarrer() {
    if (!('IntersectionObserver' in window)) return;
    io = new IntersectionObserver(traiter, { threshold: [0, SEUIL, 0.6] });
    balayer();
    // la galerie est re-generee au changement de variante
    new MutationObserver(planifierBalayage).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('deferred-media').then(demarrer, demarrer);
  } else {
    demarrer();
  }
})();
